import { Modal } from "antd";
import { FC } from "react";
import { BookingForm } from "./booking-form";
import { useBooking } from "~/store";

type Props = {};

export const BookingModal: FC<Props> = () => {
  const { isOpen, closeBookingModal } = useBooking();
  return (
    <Modal
      open={isOpen}
      onCancel={closeBookingModal}
      closeIcon={null}
      footer={null}
      width={"70%"}
      destroyOnHidden
    >
      <BookingForm />
    </Modal>
  );
};
